import { AxiosResponse } from 'axios'
import axiosApi from '../api/axios-api'

export default {
	journalEntitySave(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/journalentity/save`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	journalEntityView(journalId: any, entityId: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/journalentity/` + journalId + `/view` + (entityId == null ? '' : '/' + entityId), null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	journalEntityUpdate(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/journalentity/update`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	journalEntityDelete(entityId: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/journalentity/delete/` + entityId, null)
				.then(function (response) {
					resolve(response);
				})
				.catch((function (error) {
					reject(error);
				}))
		})
	}
}
